export enum SchoolStatus{
    Active,
    Inactive
}
export enum StudentStatus{
    Active,
    Inactive
}